import React from 'react'
import classNames from 'classnames'

import './style.scss'

class Choice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCorrect: false,
      choosen: false,
    }
  }
  onButtonClick(b, index) {
    if (!this.props.showCorrect) {
      if (index !== this.state.choosen) {
        this.setState({
          choosen: index,
          isCorrect: b.correct
        })
        if (this.props.answerReadyToCommit) {
          this.props.answerReadyToCommit(true)
        }
      }
      else {
        this.setState({
          choosen: false,
          isCorrect: false
        })
        if (this.props.answerReadyToCommit) {
          this.props.answerReadyToCommit(false)
        }
      }
    }
  }
  fresh() {
    this.setState({
      choosen: false,
      isCorrect: false
    })
  }
  render() {
    const { choice, showCorrect } = this.props
    return (
      <div className="quiz-choice">
        {
          choice.map((thing, index) => {
            const isChoosen = this.state.choosen === index
            let btnClassNames = classNames([
              'quiz-choice-button',
              {
                'selected': isChoosen,
                'correct': thing.correct && showCorrect,
                'wrong': isChoosen && showCorrect && !thing.correct
              }
            ])
            return (<div key={index} className={btnClassNames} onClick={() => {this.onButtonClick(thing, index)}} dangerouslySetInnerHTML={{ __html: thing.text }}/>)
          })
        }
      </div>
    )
  }
}

export default Choice
